export default {
  S: `@media (min-width: 550px)`,
  M: `@media (min-width: 768px)`,
}